import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class KindModel extends BaseModel {

    constructor() {
        super({
                name: "kind",
                tableName: 'kind',
                label: "Loại",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: { 
                    name: 'name',
                    type: "String",
                    class: "center",
                    label: 'Tên loại',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                weight:{
                    name: 'weight',
                    type: "String",
                    class: "center",
                    label: 'Cân nặng',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    display: false
                },
                growth: {
                    name: 'growth',
                    type: "Double",
                    class: "center",
                    label: 'Tốc độ tăng trưởng/ngày (%)',
                    filter: {
                        type: 'input',
                        match: 'equals',
                        validate: (value) => !isNaN(value.replace(',', '.'))
                    },
                },
                number_days_growth: {
                    name: 'number_days_growth',
                    type: "String",
                    class: "center",
                    label: 'Số ngày tăng trưởng'
                },
                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày tạo',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
                code: {
                    name: 'code',
                    type: "String",
                    display: false
                },
                type: {
                    refs: 'type {id name}',
                    display: false
                },
                obj_boxes: {
                    refs: 'obj_boxes {weight date_growth total unit_id unit {id farm_id farm {id name}}}',
                    display: false
                },
            },
            )
    }

}